import { call, put, takeEvery } from "redux-saga/effects";
import { TIPSTER_REQUEST } from "../../constants/tipster";
import { getTipster } from "../../api/tipsters";
import { tipsterActions } from "../../store/tipster/actions";

function* tipsterRequestSaga(action: any): any {
  try {
    const tipster = yield call(getTipster, action.payload);
    yield put(tipsterActions.tipsterSuccessAction(tipster));
  } catch (e: any) {
    yield put(tipsterActions.tipsterFailureAction(e));
  }
}

function* tipsterSaga() {
  yield takeEvery(TIPSTER_REQUEST, tipsterRequestSaga);
}

export default tipsterSaga;
